import { render, staticRenderFns } from "./ImgZoomWindow.vue?vue&type=template&id=ea8fbd8c&"
import script from "./ImgZoomWindow.vue?vue&type=script&lang=js&"
export * from "./ImgZoomWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports